'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _commonMenuItem = require('./commonMenuItem');

var _commonMenuItem2 = _interopRequireDefault(_commonMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Builder for menu item
 * @property {CommonMenuItem|Function|exports|module.exports} ItemConstructor
 * @constructor
 */
/**
 * @module navigation/commonItemBuilder
 * @requires module: navigation/commonMenuItem
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function CommonMenuItemBuilder() {}

/**
 * Default class for highlighted menu item
 * @type {string}
 */


/**
 * @type {CommonMenuItem|Function|exports|module.exports}
 */
CommonMenuItemBuilder.prototype.activeClass = 'ui-link_selected';

/**
 * Default menu item link attributes
 * @type {{target: string}}
 */
CommonMenuItemBuilder.prototype.defaultAttributes = {
    target: '_self'
};

/**
 * Default item HTML template
 * @type {string}
 */
CommonMenuItemBuilder.prototype.template = '<li class="{{outerClass}}"><a href="{{href}}" class="{{innerClass}}">{{title}}</a></li>';

/**
 * Build item object
 * @public
 * @param {string|jQuery} [title]
 * @param {string} [href]
 * @param {object} [attributes]
 * @returns {CommonMenuItem|*}
 */
CommonMenuItemBuilder.prototype.getMenuItem = function (title, href, attributes) {
    var $object;
    var clonedAttributes = _jquery2.default.extend({}, attributes);

    if (arguments[0] instanceof _jquery2.default) {
        $object = (0, _jquery2.default)(arguments[0]);
    } else {
        $object = (0, _jquery2.default)(this.buildTemplate(title, href));
        clonedAttributes.class = this.innerClass + ' ' + (clonedAttributes.class || '');
        $object.children().attr(_jquery2.default.extend({}, this.defaultAttributes, clonedAttributes));
    }

    return this.buildItem($object);
};

/**
 * @protected
 * @param {jQuery} $object
 * @returns {CommonMenuItem|*}
 */
CommonMenuItemBuilder.prototype.buildItem = function ($object) {
    if (typeof this.ItemConstructor !== 'function') {
        throw new Error('ItemConstructor property is not a function');
    }

    var item = new this.ItemConstructor($object, this.activeClass);

    if (!(item instanceof _commonMenuItem2.default)) {
        throw new Error('Item object is not instance of CommonMenuItem');
    }

    return item;
};

/**
 * @protected
 * @returns {string}
 */
CommonMenuItemBuilder.prototype.buildTemplate = function (title, href) {
    return this.template.replace('{{outerClass}}', this.outerClass).replace('{{innerClass}}', this.innerClass).replace('{{title}}', title).replace('{{href}}', href);
};

exports.default = CommonMenuItemBuilder;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/commonMenuItemBuilder.js
// module id = 994
// module chunks = 1